import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';

import { ExitPointsAdjustmentHistoryService } from '@/app/core/services/exit-points-adjustment-history/exit-points-adjustment-history.service';
import {
  GetExitPointsAdjustmentHistoryAction,
  ClearExitPointsAdjustmentHistoryAction,
} from './exit-points-adjustment-history.actions';
import { catchError, tap, throwError } from 'rxjs';
import { IExitPointsAdjustmentHistory } from '@/app/core/interfaces/exit-points-adjustment-history.interface';
import { MatDialog } from '@angular/material/dialog';
import { EnovaAlertsComponent } from '@/app/core/utils/enova-alerts/enova-alerts.component';

export interface ExitPointsAdjustmentHistoryStateModel {
  historyData: IExitPointsAdjustmentHistory[];
  puntoSalidaUuid: string | null;
  fecha: string | null;
}

export const initialState: ExitPointsAdjustmentHistoryStateModel = {
  historyData: [],
  puntoSalidaUuid: null,
  fecha: null,
};

@State<ExitPointsAdjustmentHistoryStateModel>({
  name: 'exitPointsAdjustmentHistory',
  defaults: initialState,
})
@Injectable()
export class ExitPointsAdjustmentHistoryState {
  @Selector() static getHistoryData(
    state: ExitPointsAdjustmentHistoryStateModel
  ): IExitPointsAdjustmentHistory[] {
    return state?.historyData || [];
  }

  @Selector() static getPuntoSalidaUuid(
    state: ExitPointsAdjustmentHistoryStateModel
  ): string | null {
    return state?.puntoSalidaUuid || null;
  }

  @Selector() static getFecha(
    state: ExitPointsAdjustmentHistoryStateModel
  ): string | null {
    return state?.fecha || null;
  }

  constructor(
    private exitPointsAdjustmentHistoryService: ExitPointsAdjustmentHistoryService,
    private dialog: MatDialog
  ) {}

  @Action(GetExitPointsAdjustmentHistoryAction)
  GetExitPointsAdjustmentHistoryAction(
    ctx: StateContext<ExitPointsAdjustmentHistoryStateModel>,
    { payload }: GetExitPointsAdjustmentHistoryAction
  ) {
    ctx.patchState({
      puntoSalidaUuid: payload.puntoSalidaUuid,
      fecha: payload.fecha,
    });

    return this.exitPointsAdjustmentHistoryService
      .getExitPointsAdjustmentHistory(payload)
      .pipe(
        tap(response => {
          ctx.patchState({ historyData: response });
        }),
        catchError(error => {
          this.dialog.open(EnovaAlertsComponent, {
            width: 'auto',
            data: {
              type: 'error',
              text:
                error?.error?.error ||
                error?.details ||
                error?.message ||
                'Ha ocurrido un error al obtener el historial de ajustes',
              hiddeCancelBtn: true,
            },
          });
          return throwError(() => error);
        })
      );
  }

  @Action(ClearExitPointsAdjustmentHistoryAction)
  ClearExitPointsAdjustmentHistoryAction(
    ctx: StateContext<ExitPointsAdjustmentHistoryStateModel>
  ) {
    ctx.setState(initialState);
  }
}

